// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"tk_a bih_a bih_r bih_j","Photos__img":"tk_b bih_b"};